import { IUserAccountStore } from '../../index'
import { INotificationReload } from '../../../../actions/notification/notifications'

export default function(
  store: IUserAccountStore,
  action: INotificationReload,
): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      count: action.notifications.count,
      countNotRead: action.notifications.countNotRead,
      countNotSeen: action.notifications.countNotSeen,
      hasMore: action.hasMore,
      isLoading: false,
      items: action.notifications.items,
    },
  }
}
